var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{class:_vm.setClases(),staticStyle:{"overflow-y":"scroll"},style:('margin-top:'+_vm.headerHeight+'px'),attrs:{"fluid":"","fill-height":"","pa-0":""}},[_c('router-view',{key:_vm.$route.params.id})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }